import React, {Component} from 'react';
import './App.css';
import Main from './containers'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import {auth} from "./logic/firebase";
import * as firebaseui from 'firebaseui'
import {Container} from '@material-ui/core'
import {env} from "./config";

Bugsnag.start({
    apiKey: 'fb14aa8e292b5026c54e71c8f114e7a6',
    plugins: [new BugsnagPluginReact(React)]
})

const ErrorBoundary = Bugsnag.getPlugin('react');

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null
        }
    }

    componentDidMount() {
        this.setUser(auth().currentUser);
        this.loginSubscription();
    }

    setUser = (user) => {
        if (user) {
            if (user.isAnonymous
                || (env === 'prod' && user.uid !== 'S51TKr1pMLR5wKRBT2TKaiirW4J3')
                || (env === 'dev' && user.uid !== 'iWOvLg482nOiBDLcJe3NMf26zB12')
                || (env === 'stage' && user.uid !== 'iWOvLg482nOiBDLcJe3NMf26zB12')
            ) {
                auth().signOut();
            } else {
                this.setState({user: user})
            }
        }
    };

    loginSubscription = () => {
        auth().onAuthStateChanged((user) => {
            if (user) {
                this.setUser(user);
            } else {
                const ui = new firebaseui.auth.AuthUI(auth());
                ui.start('#firebaseui-auth-container', {
                    signInSuccessUrl: '/',
                    signInOptions: [
                        auth.EmailAuthProvider.PROVIDER_ID
                    ],
                });
            }
        })
    };

    render() {
        const {user} = this.state;
        if (!user) {
            return <Container style={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingLeft: 0,
                paddingRight: 0
            }} maxWidth={false}>
                <div id="firebaseui-auth-container"/>
            </Container>
        }
        return <ErrorBoundary><Main/></ErrorBoundary>
    }
}

export default App;
